// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".\\---base-ui-form__form,\n.\\---base-ui-form__fieldset {\n  display: contents;\n}\n", "",{"version":3,"sources":["webpack://./../base/ui/form.css"],"names":[],"mappings":"AAAA;;EAEE,iBAAiB;AACnB","sourcesContent":[".form,\n.fieldset {\n  display: contents;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"form": "---base-ui-form__form",
	"fieldset": "---base-ui-form__fieldset"
};
export default ___CSS_LOADER_EXPORT___;
